module.exports = __webpack_public_path__ + "static/media/img-destaque-home.3873623e.jpg";